export default __webpack_public_path__ + "static/media/cow_study.ae99640e.png";